export const registerMixpanelEvent = name => {
  // eslint-disable-next-line no-undef
  if (typeof mixpanel !== 'undefined' && name) {
    // eslint-disable-next-line no-undef
    mixpanel.register({
      Location: name.replace('_', ' '),
    });
  }
};

export const mixpanelEventTrack = event => {
  window.mixpanel.track(event);
};
